import {
  FC,
  forwardRef,
  InputHTMLAttributes,
  LabelHTMLAttributes,
} from 'react';
import cx from 'clsx';
import styles from './TextField.module.css';
import { LFC } from '../../types';

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  focused: boolean;
}

export const Label: FC<LabelProps> = ({
  focused,
  children,
  className,
  ...props
}) => (
  <label
    className={cx(styles.label, className, { [styles.labelFocused]: focused })}
    {...props}
  >
    {children}
  </label>
);

export const Error: LFC = ({ children }) => (
  <div className={styles.errorMsg}>{children}</div>
);

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error, className, ...props }, ref) => (
    <input
      ref={ref}
      className={cx(styles.input, className, { [styles.error]: error })}
      {...props}
    />
  )
);

export const InputWithContent = forwardRef<HTMLInputElement, InputProps>(
  ({ error, className, children, ...props }, ref) => (
    <div className={styles.inputWithContent}>
      <input
        ref={ref}
        className={cx(styles.input, styles, className, {
          [styles.error]: error,
        })}
        {...props}
      />
      <div className={styles.inputContent}>{children}</div>
    </div>
  )
);
